import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=b8cbc26e&scoped=true"
import script from "./Page.vue?vue&type=script&lang=ts"
export * from "./Page.vue?vue&type=script&lang=ts"
import style0 from "./Page.vue?vue&type=style&index=0&id=b8cbc26e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8cbc26e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8cbc26e')) {
      api.createRecord('b8cbc26e', component.options)
    } else {
      api.reload('b8cbc26e', component.options)
    }
    module.hot.accept("./Page.vue?vue&type=template&id=b8cbc26e&scoped=true", function () {
      api.rerender('b8cbc26e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reminder-layout-editor/Page.vue"
export default component.exports